import { FC } from 'react';

import { Link } from '@remix-run/react';
import StarRating from '~/components/star-rating';
import { Button } from '~/components/ui/button';
import { getHomepageAuctionHouseList } from '~/services/api/auction-houses';

interface AuctionHousesProps {
  data: Awaited<ReturnType<typeof getHomepageAuctionHouseList>>;
}

export const AuctionHouseItem: FC<{
  auctionHouse: Awaited<ReturnType<typeof getHomepageAuctionHouseList>>[0];
}> = ({ auctionHouse }) => {
  return (
    <div key={auctionHouse.id} className={`flex w-full flex-col items-center gap-3 rounded-lg border py-4`}>
      <img
        src={auctionHouse.image}
        alt={`${auctionHouse.name}`}
        className="h-20 w-20 rounded-lg border object-contain"
      />
      <div className="flex flex-col items-center gap-2 px-[5%]">
        <p className="rounded-full bg-slate-200 px-2 py-1 text-xs font-normal capitalize">{auctionHouse.type}</p>
        <p className="font-semibold text-black">{auctionHouse.name}</p>
        <p className="text-sm text-slate-500">{auctionHouse.auctionCount} auctions found</p>
        <div className="flex flex-row items-center gap-2">
          <StarRating rating={auctionHouse.rating} size={16} />
          <p className="text-xs font-normal text-[#646464]">{auctionHouse.reviewCount} Reviews</p>
        </div>
        <div className="mt-2 w-full">
          <Link to={`/auction-house/${auctionHouse.slug}`}>
            <Button variant={'outline'} className="w-full border-black" size="sm">
              Explore
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

const AuctionHouses: FC<AuctionHousesProps> = ({ data }) => {
  return (
    <div className="flex flex-col">
      <p className="text-xl font-medium text-black">Explore Auction Houses</p>
      <p className="mb-4 text-xs font-normal text-[#646464]">{data.length} auction house(s) found</p>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {data.map((auctionHouse) => (
          <AuctionHouseItem key={auctionHouse.id} auctionHouse={auctionHouse} />
        ))}
      </div>
      <Link className="my-10 flex justify-center" to="/auction-houses">
        <Button variant={'outline'}>Explore All Auction Houses</Button>
      </Link>
    </div>
  );
};

export default AuctionHouses;
